import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getSessionState } from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RegistrationCompletedGuard implements CanActivate {
	constructor(
		private store: Store<any>,
		private router: Router
	) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.store.pipe(
			select(getSessionState),
			filter(x => x && x.isLoaded),
			map(u => !!u),
			tap(isCompleted => {
				if (isCompleted) {
					this.router.navigate(['/account/contract/details']);
				}
			})
		);
	}
}
